import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { EMPTY, Subscription, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { editableRole } from 'src/app/helpers/enums/role-type.enum';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EstimatesService } from 'src/app/services/estimates/estimates.service';
import { InformationService } from 'src/app/services/information/information.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-flags',
  templateUrl: './flags.component.html',
  styleUrls: ['./flags.component.scss']
})
export class FlagsComponent implements OnInit {
  public loaded: boolean = false;
  public submitted: boolean = false;
  public userData: string = null;
  public role: string = null;
  public lang: string = null;
  public flagsForm: UntypedFormGroup = null;
  public flags: any[] = [];
  public flagsAll: Object = {};
  public editableRole: string[] = [];
  public informationObj: Object = {};

  public subscriptions: Subscription[] = [];
  public disableForm: boolean = false;

  constructor(
    public formBuilder: UntypedFormBuilder,
    public router: Router,
    public location: Location,
    public sharedService: SharedService,
    public authService: AuthService,
    public userService: UserService,
    public estimateService: EstimatesService,
    public localeService: LocaleService,
    public informationService: InformationService
  ) {
    this.getUserData();
    this.editableRole = editableRole;
    this.flagsForm = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.localeService.localeSubject.subscribe((res) => {
      this.lang = res;
    });

    this.sharedService.vinInformation.subscribe((res) => {
      res ? (this.informationObj = res) : (this.informationObj = null);
    });

    this.getFlags();

    // START => getting report status of a vehicle from API the disable the form
    const payload = { vehicle_id: this.sharedService.getVehicleId };

    this.informationService.getVehicleStatus(payload).subscribe((res: object) => {
      const vehicleStatus = Object.values(res['data']);

      // this.disableForm = res['data']['gallery'];
      // vehicleStatus.every((status: boolean) => status === true)
    });
    // END
  }

  getUserData() {
    const userDataSub = this.authService.userSubject.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'admin';
    });

    this.subscriptions.push(userDataSub);
  }

  get formData() {
    return this.flagsForm.controls;
  }

  getFlags() {
    this.loaded = true;

    this.userService.GetFlags().subscribe((res) => {
      let success = res['success'];
      let data: object[] = res['data'];

      if (success) {
        this.loaded = false;
        for (let control of data) {
          control['short_name'] = control['flag_name'].replace(/[\s]/g, '_').toLowerCase();
          this.flagsForm.addControl(control['short_name'], new UntypedFormControl(false));
          // this.flagsForm.addControl(control['flag_id'], new UntypedFormControl(false));
          this.flags.push(control);
        }
        this.getFlagsSelected(data);
        this.flagsForm.updateValueAndValidity();
      }
    });
  }

  getFlagsSelected(controls: object[]) {
    const vehicle_id = { vehicle_id: this.sharedService.getVehicleId };
    this.userService.GetVinInfo(vehicle_id).subscribe(
      (res) => {
        let success = res['success'];
        let data = res['data'];

        if (success && Object.keys(data).length) {
          const flagsData: Object = this.sharedService.flags.value || null;
          const vehicleSelectedFlags = data['vehicle_flags_data']
            ? data['vehicle_flags_data']['flags']
            : [];

          /**
           * This is for the new implementation where we are storing the entire object with Arabic translations
           * inside an array and not an object.
           */
          if (Array.isArray(vehicleSelectedFlags)) {
            console.log("Inside the new implementation - 1354");
            
            for (let control of controls) {
            if (vehicleSelectedFlags) {
              for (let i = 0; i < vehicleSelectedFlags.length; ++i) {
                if (control['short_name'] === vehicleSelectedFlags[i]['short_name']) {
                  this.flagsForm.get(vehicleSelectedFlags[i]['short_name']).setValue(true);
                }
              }
            } else {
              for (let flag in flagsData) {
                if (flag === control['short_name']) {
                  this.flagsForm.get(flag).setValue(flagsData[flag]);
                }
              }
            }
          }
          }
          /**
           * This is for the old implementation where we are storing the only the `short_name` into an object
           */
          else {
            console.log("Inside the old implementation - 1354");
            for (let control of controls) {
            if (vehicleSelectedFlags) {
              for (let flag in vehicleSelectedFlags) {
                if (flag === control['short_name']) {
                  this.flagsForm.get(flag).setValue(vehicleSelectedFlags[flag]);
                }
              }
            } else {
              for (let flag in flagsData) {
                if (flag === control['short_name']) {
                  this.flagsForm.get(flag).setValue(flagsData[flag]);
                }
              }
            }
          }
          }
        }
      },
      (error) => {}
    );
  }

  saveData() {
    this.submitted = true;
    //Validating form fields
    if (this.flagsForm.invalid) {
      return false;
    } else {
      const set = new Set<string>();
      for (const [key, value] of Object.entries(this.flagsForm.value)) {
        if (value) set.add(key)
      }
      const flagsArray = []

      for (let i = 0; i < this.flags.length; ++i) {
        if (set.has(this.flags[i].short_name)) {
          flagsArray.push({
            flag_id: this.flags[i].flag_id,
            flag_name: this.flags[i].flag_name,
            flag_name_arabic: this.flags[i].flag_name_arabic,
            short_name: this.flags[i].short_name
          })
        }
      }

      const flagObj: Object = {
        vehicle_id: this.sharedService.getVehicleId,
        // flags: this.flagsForm.value
        flags: flagsArray
      };
      const flagsData: FlagsData = {
        vehicle_id: this.sharedService.getVehicleId,
        vehicle_flags_data: JSON.stringify(flagObj)
      };

      this.sharedService.setFlags = this.flagsForm.value;

      this.userService
        .SaveFlags(flagsData)
        .pipe(
          switchMap((res) =>
            res['success']
              ? this.role === 'evaluator'
                ? this.estimateService.updateRevamCount({
                    vehicle_id: this.sharedService.getVehicleId
                  })
                : of(null)
              : EMPTY
          ),
          tap(() => {
            this.router.navigate([`/vam/rating`]);
          })
        )
        .subscribe({
          error: () => {}
        });
    }
  }
}

interface FlagsData {
  vehicle_id: string;
  vehicle_flags_data: Object;
}
